import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPlay = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--play")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M6,4.83330107 L6,19.1699701 L17.1507426,12.0016356 L6,4.83330107 Z M5.54075759,2.16045709 L19.5407576,11.1604571 C20.1530808,11.5540934 20.1530808,12.4491777 19.5407576,12.842814 L5.54075759,21.842814 C4.87524596,22.270643 4,21.7928014 4,21.0016356 L4,3.00163557 C4,2.21046977 4.87524596,1.73262818 5.54075759,2.16045709 Z" id="icon--centivo--play"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-970.000000, -973.000000)"/>
          <g id="Icon/play">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--play"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--play"/>
          </g>
      </g>
  </IconWrapper>
)
